// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_GX8","cls2":"ResearchInterestDirectorySearch-cls2__0j ResearchInterestDirectorySearch-cls1_GX8"};